import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

class IntegerField extends React.Component {
  validateMinMax = (value) => {
    const { min, max } = this.props;
    let finalValue = value;
    finalValue = finalValue < min ? min : finalValue;
    finalValue = finalValue > max ? max : finalValue;
    return finalValue;
  };

  isValid = (value) => {
    const { min } = this.props;
    const hasValidLength = (value.length < 10 && !value.includes('-')) || (value.length < 11 && value.includes('-'));
    const regex = min >= 0 ? /^\d*$/ : /^-?\d*$/;
    return hasValidLength && regex.test(value);
  };

  step = (input, stepValue) => {
    input.onChange(this.validateMinMax((parseInt(input.value, 10) || 0) + stepValue));
  };

  keyboardStep = (input, e) => {
    if (e.keyCode === 38) {
      this.step(input, 1);
    } else if (e.keyCode === 40) {
      this.step(input, -1);
    }
  };

  renderStepperButton = (className, input, label, stepValue) => (
    <div
      className={className}
      role="button"
      tabIndex={0}
      onMouseDown={() => this.step(input, stepValue)}
      onKeyDown={(e) => this.keyboardStep(input, e)}
    >
      {label}
    </div>
  );

  renderFieldContent = ({ id, input, disabled }) => (
    <div className="fieldWrapper">
      <input
        id={id}
        type="text"
        autoComplete="off"
        maxLength={10}
        pattern={/^-?\d*$/}
        disabled={disabled}
        value={input.value}
        onFocus={input.onFocus}
        onBlur={input.onBlur}
        onKeyDown={(e) => this.keyboardStep(input, e)}
        onChange={(e) => {
          const { value } = e.target;
          if (this.isValid(value)) {
            input.onChange((value === '-' || value === '') ? value : this.validateMinMax(parseInt(value, 10) || 0));
          }
        }}
      />
      <div className="stepper">
        {this.renderStepperButton('plus', input, '+', 1)}
        {this.renderStepperButton('minus', input, '-', -1)}
      </div>
    </div>
  );

  customValidation = (value) => {
    const { min, max, required } = this.props;
    const parsedValue = value && parseInt(value, 10);
    if (required && !value && value !== 0) {
      return 'general.mandatoryField';
    }
    if (value && value.length && Number.isNaN(parsedValue)) {
      return Monet.I18n.getResourcesByKey('general.integerField.errorInt');
    }
    if ((min !== -999999999 && max !== 999999999) && parsedValue && (parsedValue < min || parsedValue > max)) {
      return Monet.I18n.translateResources('general.integerField.errorMinMax', { min, max });
    }
    if (min !== -999999999 && parsedValue && parsedValue < min) {
      return Monet.I18n.getResourcesByKey('general.integerField.errorMin', min - 1);
    }
    if (max !== 999999999 && parsedValue && parsedValue > max) {
      return Monet.I18n.getResourcesByKey('general.integerField.errorMax', max + 1);
    }
    return undefined;
  };

  gridFormatter = ({ label, name }) => ({
    id: name,
    name,
    label,
    type: 'INTEGER'
  });

  render() {
    return (
      <BaseField
        fieldClassName="integerField"
        renderFieldContent={this.renderFieldContent}
        customValidation={this.customValidation}
        gridFormatter={this.gridFormatter}
        {...this.props}
      />
    );
  }
}

IntegerField.propTypes = {
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number
};

IntegerField.defaultProps = {
  disabled: false,
  required: false,
  min: -999999999,
  max: 999999999
};

export default IntegerField;
